<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0"> تراکنش های  کاربران</h5>
                            </a-col>
                            <a-col :span="24" :md="12"
                                style="
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                  ">
                                <a-button class="btn-outline-purple" icon="search" @click="isHidden = !isHidden">
                                    جستجو
                                </a-button>
                                &nbsp;

                            </a-col>
                        </a-row>
                    </template>

                    <b-card style="margin:20px; !important ; border:none;" v-if="isHidden">
                            <a-col style="margin-top: 20px" :md="3">
                                <a-button class="btn-outline-green w-100" icon="search" @click="getData">
                                    جستجو
                                </a-button>

                            </a-col>
                            <a-col :md="7">
                                <label class="sr-only" for="inline-form-input-name">نوع تراکنش</label>
                                <select class="form-control" v-model="search.type">
                                    <option value="">انتخاب</option>
                                    <option value="in">ورودی</option>
                                    <option value="out">خروجی</option>
                                </select>
                            </a-col>
                            <a-col :md="7">
                                <label class="sr-only" for="inline-form-input-name">نوع حساب</label>
                                <select class="form-control" v-model="search.account">
                                    <option value="">انتخاب</option>
                                    <option value="investment">سرمایه اولیه</option>
                                    <option value="barter">تهاتری</option>
                                    <option value="wallet">کیف پول</option>
                                </select>
                            </a-col>
                            <a-col :md="7">
                                                          <UserSearch @ids="getIds" />

                            </a-col>
                          
                    </b-card>
                    <a-row style="justify-content: center; display: flex" v-if="$store.state.loading">
                        <template>
                            <div>
                                <a-spin />
                            </div>
                        </template>
                    </a-row>
                    <div v-else>
                        <section class="w-100 p-4 text-center">
                                                            <div class="table-responsive">

                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">شناسه</th>
                                        <th scope="col">کاربر</th>
                                        <th scope="col">مقدار</th>
                                        <th scope="col">نوع تراکنش</th>
                                        <th scope="col">  نوع حساب</th>
                                        <th scope="col">   واریز سود</th>
                                        <th scope="col"> توضیحات</th>
                                        <th scope="col"> تاریخ</th>
                                        <th scope="col"> مانده</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in data">
                                        <th scope="row">#{{ row.id }}</th>
                                        <th scope="row">{{row.user ?  $root.full_name(row . user . firstname , row . user . lastname) : '' }}</th>
                                        <td>
                                           

                                            <b-badge variant="light" class="text-dark">
                                                {{ $root . number_format(row.amount) }}
                                            </b-badge>
                                        </td>
                                        <td>
                                            <b-badge v-if="row.type == 'in'" variant="light" class="bg-success">
                                                ورودی</b-badge>

                                                <b-badge v-else variant="light" class="bg-danger">
                                                خروجی</b-badge>
                                          
                                        </td>

                                        <td>
                                            <b-badge v-if="row.account == 'barter'"  pill variant="info" class="bg-dark">
                                               تهاتری
                                            </b-badge>
                                            <b-badge v-else-if="row.account == 'wallet'"  pill variant="info" class="bg-dark">
                                               کیف پول
                                            </b-badge>
                                            <b-badge v-else pill variant="info" class="bg-dark">
                                               سرمایه اولیه
                                            </b-badge>
                                        </td>
                                        <td>
                                            <a-avatar size="small" v-if="row.is_profit" slot="avatar"
                                        style="background-color: #EDF9E7">
                                        <svg width="10" height="10" viewBox="0 0 20 20" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path class="fill-success" fill-rule="evenodd" clip-rule="evenodd"
                                                d="M10 3C10.5523 3 11 3.44772 11 4V9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H11V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V11H4C3.44772 11 3 10.5523 3 10C3 9.44771 3.44772 9 4 9L9 9V4C9 3.44772 9.44772 3 10 3Z" />
                                        </svg>
                                    </a-avatar>
                                   
                                    <a-avatar size="small" v-else slot="avatar"
                                        style="background-color: #FEE9EA">
                                        <svg width="10" height="10" viewBox="0 0 20 20" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path class="fill-danger" fill-rule="evenodd" clip-rule="evenodd"
                                                d="M5 10C5 9.44772 5.44772 9 6 9L14 9C14.5523 9 15 9.44772 15 10C15 10.5523 14.5523 11 14 11L6 11C5.44772 11 5 10.5523 5 10Z" />
                                        </svg>
                                    </a-avatar>
                                          
                                        </td>
                                        <td>
                                           <p>
                                            {{row.description}}
                                           </p>
                                        </td>
                                             <td>
                                           <p>
                                            {{new Date(row.created_at).toLocaleDateString('fa-IR')}}
                                           </p>
                                        </td>

                                        <td>
                    

                                           <b-badge v-if="row.balance" variant="light" class="text-dark">
                                                {{ $root . number_format(row.balance.progressive_balance) }}
                                            </b-badge>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </section>
                        <a-row class="pagination">
                            <a-pagination :total="total" :item-render="$root.itemRender"
                                @change="getData(currentPage)" v-model="currentPage" />
                        </a-row>
                    </div>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>
<script>
    import ModalChange from "../../components/Financials/ModalChange.vue"
    import UserSearch from "../../components/Blocks/UserSelectMultiple.vue"

    export default {
        components: {
            ModalChange,
            UserSearch
        },
        data() {
            return {
                data: [],
                currentPage: 1,
                total: 0,
                isHidden: false,
                search: {
                    account: "",
                    type: "",
                    user_id:[]
                },
            };
        },
        methods: {
             getIds(value) {
                console.log(value)
                this.search.user_id=value

            },
             async getData() {
                let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/transactions?page=${this.currentPage}&&account=${this.search.account}&&type=${this.search.type}&&user_id=${this.search.user_id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        console.log(response)
                        _this.data = response.data.data;
                        _this.$store.state.loading = false;
                        _this.total = response.data.total;
                        _this.currentPage = response.data.current_page;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            deleteRow(url) {
                this.$swal({
                    title: "آیا از حذف اطلاعات اطمینان دارید؟",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: "بله",
                    denyButtonText: "لغو",
                }).then((result) => {
                    if (result.isConfirmed) {
                        let _this = this;
                        axios
                            .get(url)
                            .then(function(response) {
                                _this.$toast.success("با موفقیت حذف شد.");
                                _this.getData();
                            })
                            .catch(function(err) {
                                _this.$root.handleAxiosError(err);
                            });
                    }
                });
            },
        },
        mounted() {
            this.getData();
        },
    };
</script>

<style scope>
    .pagination {
        display: flex;
        justify-content: center;
        margin: 15px;
    }
</style>
